import { render, staticRenderFns } from "./asRegToNu.vue?vue&type=template&id=2be4143a&scoped=true&"
import script from "./asRegToNu.vue?vue&type=script&lang=js&"
export * from "./asRegToNu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4143a",
  null
  
)

export default component.exports